import { lazy } from 'react';

export const LazyIntegrationWorkflowStatusPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--integration-workflow-status-page" */ './integration-workflow-status-page'
    ),
);
